import classNames from "classnames";
import HideIf from "util/HideIf";
import styles from "./new-product-filter.module.scss";

function FilterLabel({
  item,
  showCount = true,
  nbcImage,
}: any) {
  return (
    <div className={styles.virtual_list}>

      <div
        className={classNames(styles.bucket_container, "justify-content-between")}
        title={item.bucket}
      >
        <span className={styles.bucket_label} style={{ background: item.color ? item.color : "", padding: item.color ? 5 : "" }}>
          {item.bucket}
        </span>

        <HideIf show={showCount}>
          <span className={styles.result_count}>
            {` (${item.count})`}
          </span>
        </HideIf>
        <HideIf show={nbcImage}>
          {nbcImage}
        </HideIf>
      </div>
    </div>
  );
}

export default FilterLabel;
